import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import routes from 'app/routes';
import { useContext as useUsersContext } from 'components/Users/Context';
// import NoPolicy from './Views/NoPolicy/Index';
import List from './Views/List/Index';
import Assign from './Views/Assign/Index';
import Success from './Views/Success/Index';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  const router = createBrowserRouter([
    // TODO: enable NoPolicy page when every enterprise has switched to policies.
    // {
    //   path: routes.managers.programs.noPolicy,
    //   element: <NoPolicy />,
    // },
    {
      path: routes.managers.programs.index,
      element: <List />,
    },
    {
      path: 'managers/programs/:templateId/assign',
      element: <Assign />,
    },
    {
      path: routes.managers.programs.success,
      element: <Success />,
    },
  ]);

  return <RouterProvider router={router} />;
}
